import { useLayoutEffect, useRef, useState } from 'react';

export function useCollectionLayout(count: number, enabled = true) {
    const collections = useRef<HTMLElement>(null);
    const [columns, setColumns] = useState(0);
    const [scrollEnds, setScrollEnds] = useState({ top: true, bottom: true });
    const updateScrollEnds = () => {
        const element = collections.current;
        if (element) setScrollEnds({ top: element.scrollTop <= 1, bottom: element.scrollTop + element.clientHeight >= element.scrollHeight - 1 });
    };
    useLayoutEffect(() => {
        const element = collections.current;
        if (!element || !enabled) return;
        const update = () => {
            const style = getComputedStyle(element);
            const width = element.getBoundingClientRect().width - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
            const capacity = Math.floor((width + 10) / 190);
            setColumns(window.innerHeight > window.innerWidth && capacity < 4 ? capacity >= 3 ? 3 : 2 : 0);
            updateScrollEnds();
        };
        const observer = new ResizeObserver(update);
        observer.observe(element); window.addEventListener('resize', update); update();
        return () => { observer.disconnect(); window.removeEventListener('resize', update); };
    }, [enabled]);
    useLayoutEffect(() => { updateScrollEnds(); }, [columns, count]);
    const scrollCollections = (direction: number) => {
        const element = collections.current;
        if (element) element.scrollBy({ top: direction * ((element.firstElementChild?.getBoundingClientRect().height || 64) + 10), behavior: 'auto' });
    };
    return { collections, columns, scrollEnds, updateScrollEnds, scrollCollections, showCollectionBars: columns > 0 && count > columns * 2 };
}
